import { z } from 'zod';
/**
 * An annotation region. Coordinates are normalized to the 0–1 range relative to
 * image width/height so they survive resizing. The discriminated `type` leaves
 * room for polygons/masks later.
 */
export const BBoxRegionSchema = z.object({
    type: z.literal('bbox'),
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    w: z.number().min(0).max(1),
    h: z.number().min(0).max(1),
    defect_type_id: z.number().int().positive().nullable().optional(),
});
/**
 * An ellipse, stored as the bounding box it is inscribed in.
 *
 * Same four numbers as a bbox on purpose: round defects — pits, blowholes,
 * droplets — are far easier to trace with an ellipse than a rectangle, but
 * nothing downstream should have to learn a second coordinate system. Training
 * crops and IoU can treat either shape as its box.
 */
export const EllipseRegionSchema = BBoxRegionSchema.extend({
    type: z.literal('ellipse'),
});
export const RegionSchema = z.discriminatedUnion('type', [
    BBoxRegionSchema,
    EllipseRegionSchema,
]);
export const RegionsSchema = z.array(RegionSchema).default([]);
//# sourceMappingURL=regions.js.map